import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import axios from 'axios';
import CardNoticias from './CardNoticias';
import { Grid, Skeleton } from '@mui/material';
import ReactHtmlParser from 'react-html-parser';

export default function CarrosselNoticias() {
    const [noticias, setNoticias] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(
                'https://cnm.org.br/api/noticias?search=marcha&limit=15&sort=created_at&order=desc&categoria=institucional',
                'https://cnm.org.br/api/noticias?limit=15&sort=created_at&order=desc&categoria=marcha-2024'
            )
            .then((response) => {
                const noticiasData = response.data.noticias.data.map((noticia) => {
                    if (!noticia.imagem.startsWith('http') && !noticia.imagem.startsWith('www')) {
                        noticia.imagem = `https://cnm.org.br${noticia.imagem}`;
                    }
                    return noticia;
                });
                
                setNoticias(noticiasData);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Erro ao obter notícias:', error);
            });
    }, []);

    const slidesScreen = [1, 3];

    function getSlidesPerView() {
        const screenWidth = window.innerWidth;

        if (screenWidth < 600) {
            return slidesScreen[0];
        } else {
            return slidesScreen[1];
        }
    }

    const limitText = (text, limit) => {
        if (text.length <= limit) {
            return text;
        }
        return text.substring(0, limit) + '...';
    };

    return (
        <Grid>
            <Swiper
                spaceBetween={15}
                loop={true}
                navigation={true}
                modules={[Pagination, Navigation]}
                slidesPerView={getSlidesPerView()}
            >
                {loading ? (
                    Array.from({ length: 5 }, (_, index) => (
                        <SwiperSlide key={index}>
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={200}
                                animation="wave"
                                sx={{ marginBottom: '0' }}
                            />
                            <Skeleton height={20} width="80%" animation="wave" />
                            <Skeleton height={20} width="60%" animation="wave" />
                            <Skeleton height={20} width="90%" animation="wave" />
                        </SwiperSlide>
                    ))
                ) : (

                    noticias.map((noticia, index) => (
                        <SwiperSlide key={index}>
                            <CardNoticias
                                imagem={noticia.imagem}
                                nomeImagem={`Imagem Indisponível ${index + 1}`}
                                titulo={noticia.titulo}
                                textoNoticia={ReactHtmlParser(limitText(noticia.conteudo, 140))}
                                linkNoticia={noticia.link}
                            />
                        </SwiperSlide>
                    ))
                )}
            </Swiper>
        </Grid>
    );
}
